import React, { useState, useEffect } from "react";
import styled from "styled-components";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import { palette } from "../../../assets/styles/Palette";
import { H1, Body1 } from "../../../assets/styles/Typography";
import { Button } from "../../../assets/styles/ButtonStyle";
import MoleculeHeader from "../../Global/components/molecules/MoleculeHeader";
import { CustomTextarea } from "../../../assets/styles/InputStyle";
import {
  AUTODISPLAY_SELECTED_CONTENT,
  AUTODISPLAY_ACTIVE_DPI_INFO,
  AUTODISPLAY_TEXT_DATA,
  AUTODISPLAY_LOCATION_DATA,
  AUTODISPLAY_DESIGN_CONCEPT,
  AUTODISPLAY_SENSOR_DATA,
  AUTODISPLAY_SELECTED_BACKGROUND,
} from "../../AtomStates";
import { useAtom } from "jotai";
import { CUSTOMER_ID } from "../../AtomStates";
import { viewDetailActivateLinkRequest } from "../../../utils/indexedDB";
import PopupWrap from "../../../assets/styles/Popup";
import OrganismDisplayViewerCustom from "../components/organisms/OrganismDisplayViewCustom";
import OrganismDisplayViewLink from "../components/organisms/OrganismDisplayViewLink";
// 배경 이미지는 사용하지 않음 (단색 배경 적용)

const PageAutodisplayViewLink = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [autoDisplaySelectedContent, setAutoDisplaySelectedContent] = useAtom(
    AUTODISPLAY_SELECTED_CONTENT
  );

  const [autoDisplayActiveDPIInfo, setAutoDisplayActiveDPIInfo] = useAtom(
    AUTODISPLAY_ACTIVE_DPI_INFO
  );

  // URL 파라미터와 쿼리 파라미터 모두 처리
  const { path } = useParams();
  const [viewId, setViewId] = useState(null);
  const [isDataLoaded, setIsDataLoaded] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [urlChecked, setUrlChecked] = useState(false);

  const [textData, setTextData] = useAtom(AUTODISPLAY_TEXT_DATA);
  const [locationData, setLocationData] = useAtom(AUTODISPLAY_LOCATION_DATA);
  const [designConcept, setDesignConcept] = useAtom(AUTODISPLAY_DESIGN_CONCEPT);
  const [sensorData, setSensorData] = useAtom(AUTODISPLAY_SENSOR_DATA);
  const [selectedBackgroundIndex] = useAtom(AUTODISPLAY_SELECTED_BACKGROUND);

  // IP 주소 상태
  const [userIP, setUserIP] = useState("");
  const [ipLoading, setIpLoading] = useState(true);
  const [ipError, setIpError] = useState("");

  // 비밀번호 표시 상태
  const [showPassword, setShowPassword] = useState(false);
  const [showErrorPopup, setShowErrorPopup] = useState(false);
  const [isConnecting, setIsConnecting] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");

  const [customerId, setCustomerId] = useAtom(CUSTOMER_ID);
  const [activateTimestamp, setActivateTimestamp] = useState("");

  const [dataType, setDataType] = useState("");
  const [sensorDataState, setSensorDataState] = useState(null);

  // viewId 추출 (URL 파라미터 또는 쿼리 파라미터에서)
  useEffect(() => {
    let extractedViewId = null;

    // 1. URL 파라미터에서 추출 (/AutodisplayViewLink/viewId)
    if (path) {
      extractedViewId = path;
    }
    // 2. 쿼리 파라미터에서 추출 (?viewId=xxx)
    else {
      const queryParams = new URLSearchParams(location.search);
      extractedViewId = queryParams.get("viewId");
    }

    setViewId(extractedViewId);
    setUrlChecked(true);
  }, [path, location.search]);

  // 비밀번호 표시/숨기기 토글
  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  // 복사/붙여넣기 방지 함수들
  const handlePreventCopy = (e) => {
    e.preventDefault();
    return false;
  };

  const handlePreventPaste = (e) => {
    e.preventDefault();
    return false;
  };

  const handlePreventContextMenu = (e) => {
    e.preventDefault();
    return false;
  };

  // IP 주소 가져오기
  // const fetchUserIP = async () => {
  //   try {
  //     setIpLoading(true);
  //     setIpError("");

  //     // ipapi.co API 사용 (무료, CORS 지원)
  //     const response = await fetch("https://ipapi.co/json/");

  //     if (!response.ok) {
  //       throw new Error(`HTTP error! status: ${response.status}`);
  //     }

  //     const data = await response.json();

  //     if (data.ip) {
  //       setUserIP(data.ip);
  //     } else {
  //       throw new Error("IP 주소를 가져올 수 없습니다");
  //     }
  //   } catch (error) {
  //     console.error("IP 주소 가져오기 실패:", error);
  //     setIpError(error.message || "IP 주소를 가져오는데 실패했습니다");

  //     // 대체 API 시도 (fallback)
  //     try {
  //       const fallbackResponse = await fetch(
  //         "https://api.ipify.org?format=json"
  //       );
  //       const fallbackData = await fallbackResponse.json();
  //       if (fallbackData.ip) {
  //         setUserIP(fallbackData.ip);
  //         setIpError("");
  //       }
  //     } catch (fallbackError) {
  //       console.error("대체 IP API도 실패:", fallbackError);
  //     }
  //   } finally {
  //     setIpLoading(false);
  //   }
  // };

  // 컴포넌트 마운트 시 IP 주소 가져오기
  // useEffect(() => {
  //   fetchUserIP();
  // }, []);

  // 디스플레이 모드일 때 body 스크롤 방지
  useEffect(() => {
    if (path) {
      // 디스플레이 모드일 때 body 스크롤 방지
      document.body.style.overflow = "hidden";
      document.documentElement.style.overflow = "hidden";

      return () => {
        // 컴포넌트 언마운트 시 원래 스타일로 복원
        document.body.style.overflow = "";
        document.documentElement.style.overflow = "";
      };
    }
  }, [path]);

  // 연결 버튼 클릭 핸들러 -> API 데이터 로드 함수로 변경
  useEffect(() => {
    const checkActivateState = async () => {
      // viewId가 없거나 이미 데이터가 로드된 경우 return
      if (!viewId || isDataLoaded || isLoading) {
        return;
      }

      try {
        setIsLoading(true);
        setIsConnecting(true);
        setShowErrorPopup(false);

        const activateTimestamp = Date.now();
        setActivateTimestamp(activateTimestamp);

        const data = {
          viewId: viewId,
          activateTimestamp: activateTimestamp,
        };

        const response = await viewDetailActivateLinkRequest(data);

        // response가 존재하는지 확인
        if (!response) {
          throw new Error("API 응답이 없습니다");
        }

        const textData =
          response.selectedMessage?.text || response.textData || "기본 메시지";
        setTextData(textData);

        let locationData = null;
        if (response.contentData) {
          locationData = {
            selectedRegion: response.contentData.selectedRegion,
            selectedDistricts: response.contentData.selectedDistricts,
          };
        }
        setLocationData(locationData);

        const dataType = response.contentData?.dataType || "";
        setDataType(dataType);
        console.log("🔍 dataType:", dataType);
        console.log("🔍 response.contentData:", response.contentData);

        if (dataType === "sensor" && response.contentData) {
          const sensorData = {
            title: response.contentData.title,
            serialCode: response.contentData.serialCode,
          };
          console.log("🔍 센서 데이터 설정:", sensorData);
          setSensorDataState(sensorData);
        } else {
          console.log(
            "🔍 센서 데이터 설정 안함 - dataType:",
            dataType,
            "contentData 존재:",
            !!response.contentData
          );
        }

        let designConcept = "light"; // 기본값
        if (response.designConcept && response.designConcept.length > 0) {
          designConcept = response.designConcept[0];
        }
        setDesignConcept(designConcept);

        setIsDataLoaded(true);

        // 무한 리다이렉션 방지: path가 이미 있다면 navigate 하지 않음
        if (!path && viewId) {
          navigate(`/AutodisplayViewLink/${viewId}`);
        }
      } catch (error) {
        console.error("연결 중 오류 발생:", error);

        // 에러 발생 시에도 isDataLoaded를 true로 설정하여 무한 재시도 방지
        setIsDataLoaded(true);

        // 잘못된 viewId인 경우 홈으로 리다이렉트
        if (error.response?.status === 404) {
          console.error("잘못된 viewId:", viewId);
          alert("존재하지 않는 경로입니다.");
          navigate("/");
          return;
        }

        // 서버 응답 메시지 추출
        const serverMessage =
          error.response?.data?.message ||
          error.response?.data?.error ||
          error.message ||
          "연결 중 오류가 발생했습니다. 다시 시도해주세요.";

        setErrorMessage(serverMessage);
        setShowErrorPopup(true);
      } finally {
        setIsConnecting(false);
        setIsLoading(false);
      }
    };

    checkActivateState();
  }, [viewId, isDataLoaded, isLoading, path, navigate]);

  // viewId가 있으면 즉시 디스플레이 뷰어 표시 (데이터 로딩과 상관없이)
  if (viewId) {
    // 기본값들로 초기화
    const safeTextData = textData || "디스플레이 연결 중...";
    const safeDesignConcept = designConcept || "light";
    // designConcept가 "dark" 또는 "다크 모드"인 경우 dark로, 그 외는 light로
    const safeThemeMode =
      safeDesignConcept === "dark" || safeDesignConcept === "다크 모드"
        ? "dark"
        : "light";

    return (
      <AutodisplayContainer
        $isDisplayMode={true}
        themeMode={safeThemeMode}
        selectedBackgroundIndex={selectedBackgroundIndex}
      >
        <OrganismDisplayViewLink
          viewId={viewId}
          activateCode=""
          activateTimestamp={activateTimestamp}
          textData={safeTextData}
          sensorSerialData={sensorDataState}
          locationData={locationData}
          themeMode={safeThemeMode}
        />
      </AutodisplayContainer>
    );
  }

  // URL을 확인하는 동안에는 아무것도 렌더링하지 않아 깜빡임을 방지
  if (!urlChecked) {
    return null;
  }

  // viewId가 없을 때만 폼 UI 표시
  return (
    <AutodisplayContainer $isDisplayMode={false}>
      {/* <MoleculeHeader />

      <MainContent>
        <HeaderSection>
          <H1 color="gray800">AutoDisplay 연결</H1>
          <Body1 color="gray600" style={{ marginTop: "12px" }}>
            디스플레이와 연결하기 위해 필요한 정보를 입력해주세요.
          </Body1>
        </HeaderSection>

        {showErrorPopup && (
          <PopupWrap title="연결 오류" onClose={() => setShowErrorPopup(false)}>
            <Body1>{errorMessage}</Body1>
            <Button
              onClick={() => setShowErrorPopup(false)}
              style={{ marginTop: "20px" }}
            >
              확인
            </Button>
          </PopupWrap>
        )}
      </MainContent> */}
    </AutodisplayContainer>
  );
};

export default PageAutodisplayViewLink;

// 스타일 컴포넌트들
const AutodisplayContainer = styled.div`
  ${({ $isDisplayMode, themeMode, selectedBackgroundIndex }) =>
    $isDisplayMode
      ? `
        width: 100vw;
        height: 100vh;
        margin: 0;
        padding: 0;
        background: #1f1f1f;
        overflow: hidden;
        position: fixed;
        top: 0;
        left: 0;
      `
      : `
        width: 100%;
        max-width: 2330px;
        margin: 0 auto;
        background: ${palette.white};
        min-height: 100vh;
      `}
`;

const MainContent = styled.main`
  max-width: 800px;
  margin: 0 auto;
  padding: 72px 40px;
  display: flex;
  flex-direction: column;
  gap: 48px;
`;

const HeaderSection = styled.div`
  text-align: center;
  padding-bottom: 24px;
  border-bottom: 1px solid ${palette.outlineGray};
`;

const FormSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 48px;
`;

const FormContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 32px;
  padding: 40px;
  background: ${palette.white};
  border: 1px solid ${palette.outlineGray};
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
`;

const FormField = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

const FormLabel = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
  margin-bottom: 4px;
`;

const RequiredMark = styled.span`
  color: ${palette.error};
  font-size: 16px;
  font-weight: 500;
`;

const HelperText = styled.div`
  margin-top: 4px;
`;

const ButtonSection = styled.div`
  display: flex;
  justify-content: center;
  gap: 16px;
  margin-top: 24px;
  padding-top: 24px;
  border-top: 1px solid ${palette.outlineGray};
`;

const InfoSection = styled.div`
  display: flex;
  justify-content: center;
`;

const InfoBox = styled.div`
  width: 100%;
  max-width: 600px;
  padding: 32px;
  background: ${palette.primaryLightest};
  border-radius: 12px;
  border: 1px solid ${palette.primary};
`;

const InfoList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

const InfoItem = styled.div`
  display: flex;
  align-items: flex-start;
  text-align: left;
`;

const IPInfoSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 20px;
  background: ${palette.primaryLightest};
  border: 1px solid ${palette.primary};
  border-radius: 8px;
  margin-bottom: 16px;
`;

const IPInfoLabel = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

const IPInfoValue = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

const RetryButton = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  padding: 4px;
  margin-top: 4px;
  align-self: flex-start;

  &:hover {
    text-decoration: underline;
  }
`;

const PasswordInputContainer = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  width: 100%;
`;

const PasswordInput = styled.input`
  width: 100%;
  padding: 16px 48px 16px 16px;
  border: 1px solid ${palette.outlineGray};
  border-radius: 10px;
  font-size: 1rem;
  line-height: 1.5;
  background: ${palette.white};
  color: ${palette.gray800};
  resize: none;
  outline: none;
  font-family: "Pretendard", "Poppins";
  transition: all 0.5s;

  &::placeholder {
    font-weight: 300;
    color: ${palette.gray300};
  }

  &:focus,
  &:hover {
    border-color: ${palette.main};
  }

  &:disabled {
    background: ${palette.gray100};
    color: ${palette.gray400};
    cursor: not-allowed;
  }

  /* 자동완성 스타일 제거 */
  &:-webkit-autofill,
  &:-webkit-autofill:hover,
  &:-webkit-autofill:focus {
    -webkit-box-shadow: 0 0 0px 1000px ${palette.white} inset;
    transition: background-color 5000s ease-in-out 0s;
  }

  /* 드래그 방지 */
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
`;

const PasswordToggleButton = styled.button`
  position: absolute;
  right: 12px;
  background: none;
  border: none;
  cursor: pointer;
  padding: 4px;
  font-size: 18px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${palette.gray500};
  transition: color 0.2s ease;

  &:hover {
    color: ${palette.primary};
  }

  &:focus {
    outline: 2px solid ${palette.primary};
    outline-offset: 2px;
    border-radius: 4px;
  }
`;
